import "./about-us.scss";
const About = () => {
  return (
    <section className="containerAbout" id="About">
      <div className="aboutH1">
        <h1 className="h1font">About Zero One Academy</h1>
      </div>

      <div className="vertical-line"></div>
      <div className="aboutP">
        <p>
          At Zero One Academy, we are passionate about inspiring and empowering
          young minds to explore the exciting world of science, technology,
          engineering, and mathematics (STEM). Our academy was founded in 2023
          with the goal of providing high-quality educational programs for
          children of all ages. We believe that every child has the potential to
          become a future innovator, problem-solver, and leader. That's why we
          offer a variety of courses, workshops, and camps that focus on
          building critical thinking, creativity, and teamwork skills. Our
          experienced instructors are dedicated to creating a safe, supportive,
          and inclusive learning environment that encourages students to take
          risks, make mistakes, and learn from their experiences. We also use
          the latest technology and teaching methods to ensure that our programs
          are engaging, interactive, and fun. At Zero One, we are committed to
          helping children develop the skills they need to succeed in the 21st
          century. Join us today and discover the endless possibilities of STEM!
        </p>
      </div>
    </section>
  );
};

export default About;
